import { camelcaseKeys } from 'src/utils/camelize-keys';
import { decamelizeKeys } from 'src/utils/decamelize-keys';
import {
  centsToDollars,
  removeReadOnlyFields,
} from 'src/utils/fieldNormalizers';

import { FranchiseFeePayout } from './_types';
import { FranchiseFeePayoutDataParams } from './franchise-fee-payout';

export function normalizeFranchiseFeePayout(payout: any): FranchiseFeePayout {
  const camelized = camelcaseKeys(payout, { deep: true });

  // Convert cent amounts to dollars for display
  if (camelized.franchiseFeesTotal) {
    camelized.franchiseFesTotalInDollars = centsToDollars(
      camelized.franchiseFeesTotal
    );
  }
  if (camelized.adjustmentsTotal) {
    camelized.adjustmentsTotalInDollars = centsToDollars(
      camelized.adjustmentsTotal
    );
  }
  if (camelized.amountOwed) {
    camelized.amountOwedInDollars = centsToDollars(camelized.amountOwed);
  }
  if (camelized.totalRevenue) {
    camelized.totalRevenueInDollars = centsToDollars(camelized.totalRevenue);
  }

  // Normalize payout adjustments
  if (
    camelized.payoutAdjustments &&
    Array.isArray(camelized.payoutAdjustments)
  ) {
    camelized.payoutAdjustments = camelized.payoutAdjustments.map(
      (adjustment: any) => ({
        ...adjustment,
        amountInDollars:
          adjustment.amountInDollars || centsToDollars(adjustment.amount),
      })
    );
  }

  // Normalize franchise fee breakdown
  if (
    camelized.franchiseFeeBreakdown &&
    Array.isArray(camelized.franchiseFeeBreakdown)
  ) {
    camelized.franchiseFeeBreakdown = camelized.franchiseFeeBreakdown.map(
      (breakdown: any) => ({
        ...breakdown,
        totalAmountInDollars:
          breakdown.totalAmountInDollars ||
          centsToDollars(breakdown.totalAmount),
        totalTransactionAmountInDollars:
          breakdown.totalTransactionAmountInDollars ||
          centsToDollars(breakdown.totalTransactionAmount),
        chargesTotalInDollars:
          breakdown.chargesTotalInDollars ||
          centsToDollars(breakdown.chargesTotal),
        refundsTotalInDollars:
          breakdown.refundsTotalInDollars ||
          centsToDollars(breakdown.refundsTotal),
      })
    );
  }

  return camelized;
}

export function denormalizeFranchiseFeePayout(
  payout:
    | FranchiseFeePayout
    | Partial<FranchiseFeePayout>
    | FranchiseFeePayoutDataParams
): any {
  const cleaned = removeReadOnlyFields(payout, [
    'id',
    'createdAt',
    'updatedAt',
    'franchiseFeesTotal',
    'adjustmentsTotal',
    'amountOwed',
    'totalRevenue',
    'periodDurationInDays',
    'amountOwedInDollars',
    'franchiseFesTotalInDollars',
    'adjustmentsTotalInDollars',
    'totalRevenueInDollars',
    'canAddAdjustments',
    'canStartPayout',
    'payoutAdjustments',
    'franchiseFeeBreakdown',
    'chargesTotal',
    'chargesTotalInDollars',
    'refundsTotal',
    'refundsTotalInDollars',
  ]);

  return decamelizeKeys(cleaned, { deep: true });
}
